import { jsx as _jsx } from "react/jsx-runtime";
import "./UnreadCount.css";
const UnreadCount = ({ unread }) => {
    return _jsx("span", { className: `pill ${unread > 0 ? "unread" : ""}`, children: unread });
};
export default UnreadCount;
